import { TimeLogCorrectionRequestKind } from '@navio/nsdk';

export const correctionRequestKindLabel: Record<TimeLogCorrectionRequestKind, string> = {
  [TimeLogCorrectionRequestKind.ADJUST_TIMES]: 'Adjust times',
  [TimeLogCorrectionRequestKind.VOID]: 'Void shift'
};
